import { useEffect, useState } from "react";

// useful reference: https://whatwebcando.today/articles/handling-service-worker-updates/

const events = new EventTarget();
let registration: ServiceWorkerRegistration | null = null;

export function notifyNewWorkerReady(reg: ServiceWorkerRegistration) {
  registration = reg;
  events.dispatchEvent(new CustomEvent("newWorkerReady"));
}
export function applyUpdate() {
  const waiting = registration?.waiting;
  if (waiting) {
    waiting.postMessage({ type: "SKIP_WAITING" });
  }
}
export function useUpdateReady() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const cb = () => setReady(true);
    events.addEventListener("newWorkerReady", cb);
    return () => events.addEventListener("newWorkerReady", cb);
  }, []);

  return ready;
}
